import { render, staticRenderFns } from "./PGPromo.vue?vue&type=template&id=740e8509&scoped=true"
import script from "./PGPromo.vue?vue&type=script&lang=js"
export * from "./PGPromo.vue?vue&type=script&lang=js"
import style0 from "./PGPromo.vue?vue&type=style&index=0&id=740e8509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e8509",
  null
  
)

export default component.exports